import React from 'react';
import '../../WebflowCss/ark-payment.webflow.css';

export type RoundButtonProps = {
  onClick: any;
  text?: string;
  className?: string;
};

export const RoundButton = ({ className, onClick, text }: RoundButtonProps) => (
  <button className={className ? `round-button ${className}` : 'round-button'} onClick={onClick}>
    {text}
  </button>
);
